import { Box } from '../global/box.js';

export class Bonus extends Box {
    constructor(element, mode) {
        super(element);
        this._trackType = 'bonus';
        this._teaserBox = this._element.querySelector('.bonus-teaser');
        this._variants = this._element.querySelector('select');
        this._variantRadio = this._element.querySelector('[name="order[bonus-variant]"]');
        this._infoBtn = this._element.querySelector('a.details');
        this._group = this._element.dataset.group;
        this._mode = mode;
        
        this.init();
    }
    
    get variantId() {
        return (this._variants) ? this._variants.value : 0;
    }
    
    get variant() {
        return this._json.variants[this.variantId] || false;
    }
    
    get title() {
        return this._json.name;
    }
    
    get text() {
        return (this.variant) ? this.variant.name : '';
    }
    
    get price() {
        let price = (this.variant) ? this.variant.price : this._json.price;
        if(this._json.category != 'device' && price == 0) {
            return false;
        }
        return price;
    }
    
    get surcharge() {
        return (this.variant) ? this.variant.surcharge : this._json.surcharge;
    }
    
    get category() {
        return (this._json.category == 'device') ? 'Gerät' : 'Prämie';
    }
    
    get isSelected() {
        return this._checkbox.checked;
    }

    get group() {
        return (this._group) ? this._group : '';
    }
    
    init() {
        super.init();
        this._element.addEventListener('click', event => {
            event.preventDefault();
            if(this._mode == 'multi' && this.isSelected) {
                this.unselect();
            } else {
                this.select();
            }
        });
        
        if(this._variants) {
            this._variants.addEventListener('change', event => {
                (this.isSelected) ? this.changed() : this.select();
            });
        }
        
        if(this._infoBtn) {
            this._infoBtn.addEventListener('click', event => {
                event.stopPropagation();
                event.preventDefault();
                this.infoBox();
            });
        }
    }

    select() {
        this.fireEvent('unselectBonuse', {bonus: this, group: this._group});
        this.update();
        this.fireEvent('selectBonus', {bonus: this});
        super.select();
    }
    
    unselect() {
        this.fireEvent('unselectBonus', {bonus: this});
        super.unselect();
    }
    
    changed() {
        this.fireEvent('selectBonus', {bonus: this});
        this.update();
    }
    
    update() {
        if(this._variantRadio) {
            this._variantRadio.checked = true;
        }
    }
    
    infoBox() {
        if(this._teaserBox.classList.contains('d-none')) {
            this._teaserBox.classList.remove('d-none');
            this._infoBtn.classList.add('active');
            this._infoBtn.innerHTML = 'weniger Infos';
        } else {
            this._teaserBox.classList.add('d-none');
            this._infoBtn.classList.remove('active');
            this._infoBtn.innerHTML = 'mehr Infos';
        }
    };
}
